import React from 'react';
import '../styles/SuccessMessage.css';

function SuccessMessage(props) {
  return <div className="SuccessMessage pa3 lh-copy" {...props} />;
}

export default SuccessMessage;
